import firebase from "./Firebase";
import Salon from "../model/Salon";
import User from "../model/User";

export default class Manager {
  static shared = null;

  /**
   * @returns {Manager}
   */
  static getInstance() {
    if (Manager.shared == null) {
      Manager.shared = new Manager();
    }

    return this.shared;
  }

  fetchData() {
    this.fetchSalons();
  }

  fetchSalons() {
    firebase
      .firestore()
      .collection("salons")
      .get()
      .then((snapshot) => {
        let documents = snapshot.docs;
        documents.forEach((doc) => {
          let salon = new Salon(doc.data());
          User.getInstance().salons.push(salon);
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }
}
